import type { FC } from 'react'
import { Error as InternalError, ErrorProps } from './error'
import { Error403 } from './error-403'
import { Error404 } from './error-404'
import { Error500 } from './error-500'

export { Error403, Error404, Error500 }

/**
 * エラーの内容によってレンダリングする内容をコントロールする関数
 * @param error Apollo Client の返すエラーインスタンス
 */
const render = (error: Error): JSX.Element => {
  console.error(error)

  if (/(permission denied)/.test(error.message)) {
    return <Error403 />
  } else if (/(is not a valid ObjectId)/.test(error.message)) {
    return <Error404 />
  } else if (
    /(NetworkError when attempting to fetch resource.)/.test(error.message) ||
    /(Failed to fetch)/.test(error.message)
  ) {
    return <Error500 />
  } else {
    return <InternalError message={error.message} />
  }
}

interface ErrorType extends FC<ErrorProps> {
  render: typeof render
}

const ErrorComponent = InternalError as ErrorType
ErrorComponent.render = render

export const Error = ErrorComponent
